"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TESTIMONIAL_RECEIVED = exports.WORKS_RECEIVED = void 0;
const BaseStore = require("fluxible/addons/BaseStore");
class ExtraStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.dispatcher = dispatcher;
        this.testimonials = [];
        this.works = [];
    }
    setTestimonials(testimonials) {
        this.testimonials = testimonials;
        this.emitChange();
    }
    getTestimonials() {
        return this.testimonials;
    }
    setWorks(works) {
        this.works = works;
        this.emitChange();
    }
    getWorks() {
        return this.works;
    }
    dehydrate() {
        return {
            works: this.works,
            testimonials: this.testimonials
        };
    }
    rehydrate(state) {
        this.works = state.works;
        this.testimonials = state.testimonials;
    }
}
exports.default = ExtraStore;
ExtraStore.storeName = 'ExtraStore';
ExtraStore.handlers = {
    WORKS_RECEIVED: 'setWorks',
    TESTIMONIAL_RECEIVED: 'setTestimonials',
};
exports.WORKS_RECEIVED = 'WORKS_RECEIVED';
exports.TESTIMONIAL_RECEIVED = 'TESTIMONIAL_RECEIVED';
